(function ($, _, w) {
    'use strict';

    let $addToCollectionDialog = null;
    const template = '<div title="<%- labels.addProductToShoppingList %>"><div class="form-group mb-1"><label class="form-label" for="existingShoppinglistSelector"><%- labels.selectShoppingList %></label><select id="existingShoppinglistSelector" class="form-control js-existing-shoppinglist-selector"><% _.each(shoppingLists, function(shoppingList, idx){%> <option value="<%=shoppingList.id %>" <%=shoppingList.id===0 ? \'selected="selected"\' : \'\' %>><%- shoppingList.name %></option> <%}); %> </select></div><button type="button" class="btn btn-primary btn-small js-action-button" data-action="addtoexistingshoppinglist"><%- labels.add %></button> <a href="<%=urls.myShoppingListsUrl %>" class="btn btn-link btn-small"><%- labels.myShoppingLists %></a><hr/><div class="form-group mb-1"><label class="form-label" for="newShoppinglistName"><%- labels.addToNewShoppingList %></label><input id="newShoppinglistName" type="text" class="form-control js-new-shoppinglist-name" placeholder="<%- labels.newShoppingList %>"/></div><button type="button" class="btn btn-primary btn-small js-action-button" data-action="addtonewshoppinglist"><%- labels.add %></button></div>';
    let systemUrls, labels;
    let isContextLoaded = false;
    let isAnonymous;

    w.showAddToCollectionPopup = function (products) {
        if (typeof (products) === 'undefined') {
            w.PubSub.publish('notification.warning', labels.noProductsFound);
        } else {
            if (!isContextLoaded) {
                $.when(getContext())
                    .done(function (ctx) {
                        systemUrls = ctx.urls;
                        labels = ctx.labels;
                        isContextLoaded = true;
                        isAnonymous = ctx.isAnonymous;

                        let $shoppingListSelector;
                        let $newShoppingListInput;

                        if (isAnonymous === true) {
                            showLoginRequiredWarning();
                        } else {
                            const dialogHtml = _.template(template, ctx);
                            $addToCollectionDialog = $(dialogHtml).dialog({
                                resizable: false,
                                modal: true,
                                autoOpen: false,
                                width: 400,
                                buttons: [
                                    {
                                        'class': 'btn btn-default',
                                        text: labels.close,
                                        click: function () {
                                            $(this).dialog('close');
                                        }
                                    }
                                ]
                            });

                            $shoppingListSelector = $addToCollectionDialog.find('.js-existing-shoppinglist-selector');
                            $shoppingListSelector.keyup(function (e) {
                                if (e.keyCode === 13) {
                                    _handleAddProductToExistingShoppingList();
                                }
                            });
                            $newShoppingListInput = $addToCollectionDialog.find('.js-new-shoppinglist-name');
                            $newShoppingListInput.keyup(function (e) {
                                if (e.keyCode === 13) {
                                    _handleAddProductToNewShoppingList();
                                }
                            });

                            const $addButton = $addToCollectionDialog.find("[data-action='addtoexistingshoppinglist']");
                            if (ctx.shoppingLists.length <= 0) {
                                $addButton.prop('disabled', true);
                                $addButton.prop('title', labels.emptyShoppingLists);

                                $shoppingListSelector.prop('disabled', true);
                            }

                            $addToCollectionDialog.find('.js-action-button').click(function (evt) {
                                evt.preventDefault();

                                const $clickTarget = $(evt.target);
                                const action = $clickTarget.data('action');

                                switch (action) {
                                    case 'addtoexistingshoppinglist':
                                        _handleAddProductToExistingShoppingList();
                                        break;
                                    case 'addtonewshoppinglist':
                                        _handleAddProductToNewShoppingList();
                                        break;
                                }
                            });

                            $addToCollectionDialog.data('products', products);
                            $addToCollectionDialog.dialog('open');
                        }

                        function _handleAddProductToExistingShoppingList() {
                            const productsToAdd = $addToCollectionDialog.data('products');
                            const selectedShoppingListId = $shoppingListSelector.val();

                            blockUI();
                            $.when(w.PublicEStore.addToShoppingList(selectedShoppingListId, productsToAdd))
                                .always(unblockUI)
                                .done(function () {
                                    w.PubSub.publish('notification.success', labels.productAddedToShoppingList);
                                    $addToCollectionDialog.dialog('close');
                                })
                                .fail(errorHandler);
                        }

                        function _handleAddProductToNewShoppingList() {
                            const productsToAdd = $addToCollectionDialog.data('products');

                            const newShoppingListName = $newShoppingListInput.val();
                            if (newShoppingListName) {
                                blockUI();
                                $.when(w.PublicEStore.addShoppingList(newShoppingListName, '', productsToAdd))
                                    .always(unblockUI)
                                    .done(function (dataContract) {
                                        const newShoppingList = dataContract.result;
                                        // Add to selector and select
                                        const $newShoppingListOption = $('<option />',
                                            { 'value': newShoppingList.shoppingListID, 'text': newShoppingList.name });
                                        $shoppingListSelector.append($newShoppingListOption);
                                        $shoppingListSelector.val(newShoppingList.shoppingListID).change();

                                        // Cleanup
                                        $newShoppingListInput.val('');

                                        // Notify
                                        w.PubSub.publish('notification.success', labels.productAddedToShoppingList);
                                        $addToCollectionDialog.dialog('close');
                                    })
                                    .fail(errorHandler);
                            } else {
                                w.PubSub.publish('notification.warning', labels.shoppingListNameIsEmpty);
                            }
                        }
                    })
                    .fail(errorHandler);
            } else if (isAnonymous === true) {
                showLoginRequiredWarning();
            } else if ($addToCollectionDialog) {
                $addToCollectionDialog.data('products', products);
                $addToCollectionDialog.dialog('open');
            }
        }

        function getContext() {
            return $.get(w.R + 'handlers/public/estoredata.ashx?a=GetAddToShoppingListContext');
        }

        function blockUI() {
            if (typeof ($.blockUI) === 'function') {
                $addToCollectionDialog.block({ message: null });
            }
        }

        function unblockUI() {
            if (typeof ($.unblockUI) === 'function') {
                $addToCollectionDialog.unblock();
            }
        }

        function errorHandler(error) {
            let message;

            if (typeof (error) === 'string') {
                message = error;
            } else {
                message = typeof (error) !== 'undefined' ? (error.message ? error.message : error.statusText) : 'Unknown error';
            }

            if (typeof (error.status) !== 'undefined' && error.status.toLowerCase() === 'unauthorized') {
                showLoginRequiredWarning();
            } else {
                w.PubSub.publish('notification.error', message);
            }
        }

        function showLoginRequiredWarning() {
            const loginUrl = typeof (systemUrls) !== 'undefined' ? $.setQueryStringParam(systemUrls.loginUrl, 'ret', encodeURIComponent(location.pathname)) : '#';
            w.PubSub.publish('notification.warning',
                {
                    text: labels.availableToRegisteredOnly + '<br /><a href="' + loginUrl + '">' + labels.loginToContinue + '</a>',
                    layout: 'center',
                    killer: true,
                    modal: true,
                    timeout: false
                });
        }
    };

    w.updateWishList = function (productId, updateType, wishListCallback) {
        $.when(getAddToWishListContext())
            .done(function (ctx) {
                systemUrls = ctx.urls;
                labels = ctx.labels;

                switch (updateType) {
                    case 'add':
                        $.when(w.PublicEStore.addToWishList(productId)).then(wishListCallback, errorCallback);
                        break;
                    case 'remove':
                        $.when(w.PublicEStore.removeFromWishList(productId)).then(wishListCallback, errorCallback);
                        break;
                    default:
                        throw "Unknown updateType: " + updateType;
                }

                function errorCallback(dataContract) {
                    if (dataContract.status.toLowerCase() === 'unauthorized') {
                        const loginUrl = typeof (systemUrls) !== 'undefined'
                            ? $.setQueryStringParam(systemUrls.loginUrl, 'ret', encodeURIComponent(location.pathname))
                            : '#';
                        w.PubSub.publish('notification.warning',
                            {
                                text: labels.availableToRegisteredOnly + '<br /><a href="' + loginUrl + '">' + labels.loginToContinue + '</a>',
                                layout: 'topCenter',
                                timeout: 10 * 1000
                            });
                    } else if (dataContract.result) {
                        _.each(dataContract.result.items,
                            function (prod) {
                                w.PubSub.publish('notification.error', prod.message);
                            });
                    }
                }
            });

        function getAddToWishListContext() {
            return $.get(w.R + 'handlers/public/estoredata.ashx?a=GetAddToWishListContext');
        }
    }
})(jQuery, _, window);